<template>
  <v-sheet class="fill-height mb-5">
    <v-layout>
      <v-app-bar color="grey-darken-3">
        <v-app-bar-nav-icon
          variant="text"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>

        <v-toolbar-title>
          <v-avatar size="50px">
            <v-img
              alt="Avatar"
              src="https://sunrise-event.com/uploads/logo.jpg"
            ></v-img>
          </v-avatar>
        </v-toolbar-title>

        <router-link :to="{ name: 'scan-attendee' }">
          <v-btn icon="mdi-qrcode-scan" color="white" variant="text"></v-btn>
        </router-link>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        :rail="rail"
        permanent
        @click="rail = true"
        color="grey-darken-3"
      >
        <v-list>
          <v-list-item
            prepend-avatar="https://sunrise-event.com/uploads/logo.jpg"
            title="Administrator"
          >
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list density="compact" nav>
          <v-list-item
            prepend-icon="mdi-view-dashboard"
            title="Dashboard"
            :to="{ name: 'dashboard' }"
            link
          ></v-list-item>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            :to="item.value"
            link
            :prepend-icon="item.icon"
            :title="item.title"
            :value="item.value"
          >
          </v-list-item>

          <v-list-item
            prepend-icon="mdi-help-circle"
            title="Help"
            @click="$router.push('help')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-information"
            title="About"
            @click="$router.push('about')"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-logout"
            title="Logout"
            @click="logout"
          ></v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-main>
        <router-view></router-view>
      </v-main>
    </v-layout>
    <v-footer
      class="text-center"
      color="grey-darken-3"
      style="position: fixed; bottom: 0; width: 100%"
    >
      <div class="text-center ma-auto"><v-icon class="mr-2">mdi-copyright</v-icon>{{ new Date().getFullYear() }} — <strong>SUNRISE EVENT</strong></div>
    </v-footer>
  </v-sheet>
</template>


<script setup>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const items = [
  {
    icon: "mdi-home",
    title: "Home",
    value: "/",
  },
  {
    icon: "mdi-calendar",
    title: "Invitation",
    value: "/invitation",
  },
];

const drawer = ref(true);
const group = ref(null);

watch(group, () => {
  drawer.value = true;
});

function logout() {
  localStorage.removeItem("token");
  router.push("/login");
}
</script>